import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';

import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

import { AuthService } from '@unico-people/shared/dashboard/data-access-auth';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';
import { DataAccessOrganizationsService } from '@unico-people/shared/dashboard/data-access-organizations';

import { SegmentEventName, SegmentTitlePage } from '@unico-people/shared/enums/utils-enums';
import { environment } from '@unico-people/shared/utils/environments';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Component({
  selector: 'ui-header',
  templateUrl: './ui-header.component.html',
  styleUrls: ['./ui-header.component.scss']
})
export class UiHeaderComponent implements OnInit {
  @ViewChild('container', { static: true }) container: any;
  @ViewChild('dropdown', { static: true }) dropdown: any;
  @Input() set menu(open: boolean) {
    this.isOpen = open;
  }
  @Output() notify = new EventEmitter<boolean>();

  isLoggedIn: any;
  isOpen = false;
  logoutBox = true;
  currentAccount: any;
  user = {
    user_name: ''
  };
  permissions: any;
  baseUrl: string;
  subscription: Subscription;
  account: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private store: Store<any>,
    private segment: TrackingSegmentService,
    private dataAccessOrganizations: DataAccessOrganizationsService,
    private activatedRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private dataAccessOrganizationsService: DataAccessOrganizationsService
  ) {
    this.user = SessionStorage.getItem('user');

    this.subscription = this.dataAccessOrganizations.onAccount().subscribe(res => {
      if (res) {
        this.currentAccount = res?.account;
      }
    });
  }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.loggedIn();

    this.store.pipe(select(fromStore.getOrganizationState)).subscribe(res => {
      this.currentAccount = res?.currentAccount;
    });

    this.verifyReceivedAccount();

    switch (this.route?.snapshot?.data?.roles) {
      case 'ongoing':
        this.baseUrl = environment.ongoing_url;
        break;
      case 'benefits':
        this.baseUrl = environment.url_benefits;
        break;
      default:
        this.baseUrl = environment.admission_url;
        break;
    }
  }

  verifyReceivedAccount(): void {
    this.route?.queryParams?.subscribe((params: Params) => {
      this.account = params?.a;
    });

    this.account = SessionStorage.getItem('currentAccount');
    const redirectAccount = SessionStorage.getItem('redirectAccount');
    if(redirectAccount && this.account === '' || this.account === null) {
      this.account = redirectAccount;
    }

    if (this.account && this.account !== '') {
      SessionStorage.setItem('currentAccount', this.account);
      this.currentAccount = this.dataAccessOrganizationsService.setOrganization(this.account);
    }
  }

  openMenu(): void {
    const body = document.getElementsByTagName('body')[0];
    this.isOpen = !this.isOpen;
    this.notify.emit(this.isOpen);

    if (this.isOpen) {
      body.classList.add('sidebar-is-open');
      this.segment.page(SegmentEventName.open_sidebar, { title: SegmentTitlePage['/all'], url: '/all' });
    } else {
      body.classList.remove('sidebar-is-open');
    }
  }

  closeMenu(): void {
    this.logoutBox = false;
  }

  offClickHandler(): void {
    this.logoutBox = true;
  }

  logout(): void {
    this.authService.logout(this.route?.snapshot?.data?.roles);
  }
}
